"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./subscription"));
__export(require("./transactions"));
const __1 = require("..");
var AccountType;
(function (AccountType) {
    AccountType["INDIVIDUAL"] = "Individual";
    AccountType["BUSINESS"] = "Organization";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var LegalEntity;
(function (LegalEntity) {
    LegalEntity["ASSOCIATION"] = "association";
    LegalEntity["CIMA"] = "cima";
})(LegalEntity = exports.LegalEntity || (exports.LegalEntity = {}));
var EntityName;
(function (EntityName) {
    EntityName["UK_CIMA"] = "UK - CIMA";
    EntityName["US_AICPA"] = "US - AICPA";
})(EntityName = exports.EntityName || (exports.EntityName = {}));
var EntityMigrationConstant;
(function (EntityMigrationConstant) {
    EntityMigrationConstant["value"] = "_1";
})(EntityMigrationConstant = exports.EntityMigrationConstant || (exports.EntityMigrationConstant = {}));
exports.LegalEntityNameMap = {
    [EntityName.UK_CIMA]: LegalEntity.CIMA,
    [EntityName.US_AICPA]: LegalEntity.ASSOCIATION,
};
exports.MembershipBodyLegalEntityMap = {
    [LegalEntity.CIMA]: __1.Product.ProductMembershipBody.CIMA,
    [LegalEntity.ASSOCIATION]: __1.Product.ProductMembershipBody.AICPA,
};
var InvoiceItemProcessingType;
(function (InvoiceItemProcessingType) {
    InvoiceItemProcessingType[InvoiceItemProcessingType["CHARGE"] = 0] = "CHARGE";
    InvoiceItemProcessingType[InvoiceItemProcessingType["DISCOUNT"] = 1] = "DISCOUNT";
    InvoiceItemProcessingType[InvoiceItemProcessingType["PREPAYMENT"] = 2] = "PREPAYMENT";
    InvoiceItemProcessingType[InvoiceItemProcessingType["TAX"] = 3] = "TAX";
})(InvoiceItemProcessingType = exports.InvoiceItemProcessingType || (exports.InvoiceItemProcessingType = {}));
var OrderType;
(function (OrderType) {
    OrderType["DONATION"] = "donation";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
//# sourceMappingURL=index.js.map